import { Box, Button, IconButton, Typography, styled } from "@mui/material";
import BrandCard from "./brand-card";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";

const CustomeColor = styled(Box)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
  width: "100%",
  marginTop: "10px",
  borderRadius: "10px",
  padding: "10px",
}));

const GradientBox = (props) => {
  return (
    <>
      <CustomeColor>
        <Box
          sx={{
            borderRadius: "10px",
            height: "20%",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h1"
            fontSize={"1rem"}
            sx={{ marginLeft: "10px" }}
          >
            {props?.header}
          </Typography>
          <IconButton
            component={Link}
            to={props?.headerUrl}
            sx={{ marginRight: "10px" }}
          >
            <ArrowForwardIcon sx={{ width: "1.5rem" }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            overflow: "scroll",
            marginTop: "10px",
            scrollbarWidth: "none",
          }}
        >
          {props?.gridItems &&
            props?.gridItems.map((items) => {
              return (
                <BrandCard
                  cardUrl={"brand/" + items?.brand_name}
                  cardText={items?.brand_name}
                  cardImage={items?.brand_image}
                />
              );
            })}
        </Box>
      </CustomeColor>
    </>
  );
};

export default GradientBox;
